<!--
 * @Author: DXG
 * @Date: 2024-04-16 16:08:26
 * @LastEditors: situgen@szkingdom.com
 * @LastEditTime: 2026-01-09 16:40:12
 * @FilePath: \kdtup-pc-web\src\bizcomponents\fund\updBonusList.vue
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
-->
<template>
    <div>
        <!-- 筛选账户 -->
        <div class="bonus-accoount">
            扣款账号：
            <el-select
                v-model="selectAccount"
                width="260"
                placeholder="请选择"
                v-on:change="getBonusList"
            >
                <el-option
                    v-for="item in accountList"
                    :key="item.bankcardid"
                    :label="item.cardLabel"
                    :value="item.bankcardid"
                ></el-option>
            </el-select>
        </div>
        <!-- 表格start -->
        <el-table :data="fund" style="width: 100%" class="tab-list-tit" max-height="800">
            <el-table-column prop="fundname" width="320" label="基金名称" align="left">
                <template slot-scope="scope">
                    <div>
                        <p>{{ scope.row.fundname }}</p>
                        <p>{{ scope.row.fundcode }}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="360" prop="cardLabel" label="扣款账号" align="left" />
            <el-table-column prop="nav" label="最新净值" align="center">
                <template slot-scope="scope">
                    <p>{{ scope.row.nav.toFixed(4) }}</p>
                    <p>{{ $util.fmtDate(scope.row.navdate) }}</p>
                    <p></p>
                    <!-- <span @click="updBonusWay(scope.row)" style="color: var(--color-primary); cursor: pointer;">{{ scope.row.defdividendmethod ? $cache.getDict('110001', scope.row.defdividendmethod) : '--' }} > </span> -->
                </template>
            </el-table-column>
            <el-table-column prop="dividendmethoddetail" label="修改分红方式" align="center">
                <template slot-scope="scope">
                    <span
                        v-if="
                            (scope.row.fundtype == '04' && scope.row.isupdatedividend !== '1') ||
                            (scope.row.businessflag && scope.row.businessflag.includes('00'))
                        "
                        style="cursor: not-allowed; color: var(--color-text-accent)"
                    >
                        {{ $cache.getDict("110001", scope.row.dividendmethod) }}
                    </span>
                    <span
                        v-else-if="scope.row.isupdatedividend !== '1'"
                        style="color: var(--color-primary); cursor: pointer"
                        v-on:click="updBonusWay(scope.row)"
                    >
                        {{ $cache.getDict("110001", scope.row.dividendmethod) }}
                        >
                    </span>
                    <span v-else style="cursor: not-allowed; color: var(--color-text-accent)">
                        {{ $cache.getDict("110001", scope.row.perdefdividendmethod) }}（待确认）
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="修改分红方式" :visible.sync="dialogVisible" class="prop" width="580px">
            <p class="dialog-title">{{ curInfo.fundname }}({{ curInfo.fundcode }})</p>
            <p class="bonus-way">
                当前分红方式:
                <span class="red-color">
                    {{ $cache.getDict("110001", curInfo.dividendmethod) }}
                </span>
            </p>

            <div class="bonus-upd">
                修改分红方式：
                <el-select v-model="selectBonusWay" placeholder="请选择">
                    <el-option
                        v-for="item in bonusWayList"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    ></el-option>
                </el-select>
            </div>
            <div v-if="isPwdCheck" class="bonus-upd tradePwd">
                交易密码：
                <el-input
                    v-model.trim="tradePwd"
                    style="width: 430px"
                    :type="pwdType"
                    placeholder="请输入交易密码"
                    :maxlength="16"
                >
                    <i
                        slot="suffix"
                        class="icon-eye-postion"
                        :class="iconCla"
                        aria-hidden="true"
                        v-on:click="pwdTypeChange"
                    />
                </el-input>
            </div>
            <div class="dialog-footer">
                <el-button class="footer-button dc-cancel-btn" v-on:click="dialogVisible = false">
                    取 消
                </el-button>
                <el-button class="footer-button" type="primary" v-on:click="confirmUpd">
                    确 定
                </el-button>
            </div>
        </el-dialog>
        <!-- 表格end -->
    </div>
</template>

<script>
import userApi from "@/api/user";
import fundApi from "@/api/fund";
export default {
    data() {
        return {
            fund: [],
            dialogVisible: false,
            curInfo: {},
            bonusWayList: [],
            selectBonusWay: "",
            selectAccount: "",
            accountList: [],
            isPwdCheck: false,
            pwdType: "password", // 密码输入框类型
            iconCla: "fa fa-eye-slash", // 密码输入框图标
            tradePwd: ""
        };
    },
    created() {
        this.judgePwdCheck();
        this.bonusWayList = this.$cache.getDict("110001");
        this.getAccounts();
        this.getBonusList();
    },
    methods: {
        updBonusWay(item) {
            if (item.sourceflag == "2") {
                this.$message.warning("请至代销机构修改");
                return;
            }
            this.curInfo = item;
            this.tradePwd = "";
            this.selectBonusWay = item.dividendmethod;
            this.dialogVisible = true;
        },
        async getAccounts() {
            const res = await userApi.getMyBankCards();
            if (res.data.data && res.data.data.length > 0) {
                let arr = res.data.data.map((item) => {
                    let curCardCode =
                        typeof item.depositcard === "string" ? item.depositcard.substr(-4) : "";
                    let cardLabel = `${
                        this.$cache.getDict("110080", item.bankcode) +
                        "-" +
                        this.$cache.getDict("110079", item.paycenterid) +
                        "(" +
                        curCardCode +
                        ")"
                    }`;
                    return Object.assign(item, { cardLabel: cardLabel });
                });
                // 根据配置参数判断是否展示柜台的卡
                arr = arr.filter((item) => {
                    return this.$util.showCounterCard() || item.banktype != "1";
                });
                const uniqueArr = [...new Set(arr.map((item) => item.bankcardid))].map((id) =>
                    arr.find((item) => item.bankcardid === id)
                );
                uniqueArr.unshift({ bankcardid: "", cardLabel: "全部" });
                this.accountList = uniqueArr;
            }
        },
        async getBonusList() {
            const res = await fundApi.getHoldingAssets({
                producttype: "@",
                bankcardid: this.selectAccount
            });
            let arr = res.data.returnList.map((item) => {
                let curCardCode =
                    typeof item.depositcard === "string" ? item.depositcard.substr(-4) : "";
                let cardLabel = `${
                    this.$cache.getDict("110080", item.bankcode) +
                    "-" +
                    this.$cache.getDict("110079", item.paycenterid) +
                    "(" +
                    curCardCode +
                    ")"
                }`;
                // if (item.dividendmethod == "0") {
                //     // 红利再投资
                //     item.dividendmethoddetail = "3";
                // } else {
                //     if (item.dividendcashbacktype == "1") {
                //         // 自动充值至钱柜
                //         item.dividendmethoddetail = "1";
                //     } else {
                //         // 发放至银行卡
                //         item.dividendmethoddetail = "2";
                //     }
                // }
                return Object.assign(item, { cardLabel: cardLabel });
            });
            this.fund = arr;
        },
        async confirmUpd() {
            if (this.selectBonusWay == this.curInfo.dividendmethod) {
                this.$message.warning("您暂未修改分红方式");
                return;
            }
            if (this.isPwdCheck && this.tradePwd.length == 0) {
                this.$message.warning("交易密码不能为空");
                return;
            }
            let param = {
                fundcode: this.curInfo.fundcode,
                sharetype: this.curInfo.sharetype,
                dividendmethod: this.selectBonusWay == "0" ? "0" : "1",
                transactionaccountid: this.curInfo.transactionaccountid,
                tradepassword: this.$util.enc(this.tradePwd) || "",
                tradmode: "0"
            };
            // if (this.selectBonusWay == "1" || this.selectBonusWay == "2") {
            //     param.dividendcashbacktype = this.selectBonusWay == "1" ? "1" : "0";
            // }
            const res = await fundApi.tradeDivideModify(param);
            if (res.code === "0") {
                this.$message({
                    type: "success",
                    message: "分红方式修改成功！"
                });
                setTimeout(() => {
                    this.getBonusList();
                    this.dialogVisible = false;
                }, 1500);
            }
        },
        async judgePwdCheck() {
            this.isPwdCheck = this.$cache.getPwdCheck("29");
        },
        /* 密码显示或隐藏处理 */
        pwdTypeChange() {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        }
        // 格式化日期
        // formatterDate(row, column, value) {
        //     return this.$util.fmtDate(value);
        // },
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/varibles";
.dialog-title {
    font-weight: 700;
    font-size: 20px;
    color: var(--color-text-primary);
    margin-top: 29px;
}

.bonus-way {
    color: var(--color-text-primary);
    font-size: 18px;
    margin-top: 40px;
}

.bonus-upd {
    font-size: 14px;
    margin-top: 20px;
    .el-select {
        width: 430px;
        margin-left: 2px;
    }
}

.tradePwd {
    margin-left: 31px;
}
.bonus-accoount {
    margin: 24px 0;
}

.red-color {
    color: var(--color-primary);
}

.dialog-footer {
    text-align: center;
    margin-top: 39px;
    margin-bottom: 12px;
}

.footer-button {
    width: 180px;
    font-size: 16px;
    height: 42px;
}
.dc-cancel-btn {
    margin-right: 40px;
}
.icon-eye-postion {
    position: relative;
    top: 10px;
}
::v-deep .el-dialog__wrapper.prop .el-dialog__header .el-dialog__title {
    font-weight: 500;
}
.el-table {
    border: 1px solid var(--color-border-base);
    &::before {
        display: none;
    }
}
</style>
